import { CaretUp, Question, QuestionMark } from '@phosphor-icons/react';
import { cva } from 'class-variance-authority';
import { ComponentProps, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { Code } from './Code';

const caretStyles = cva(['transition-transform'], {
  variants: {
    open: {
      true: { 'rotate-180': true },
      false: { 'rotate-0': true }
    }
  }
});

export function Help(props: ComponentProps<'div'>) {
  const { className, ...rest } = props;
  const [showHelp, setShowHelp] = useState(false);
  return (
    <div className={twMerge('relative', className)} {...rest}>
      <button
        className="w-8 h-8 grid place-items-center border-black border"
        onClick={() => {
          setShowHelp(!showHelp);
        }}
      >
        {/* <CaretUp className={caretStyles({ open: showHelp })} /> */}
        <QuestionMark size={20} />
      </button>
      {showHelp && (
        <div className="absolute bottom-full right-0  p-4 overflow-hidden flex flex-col max-h-[50vh] w-[50vw] text-neutral-700 font-terminal">
          <div className="bg-white border border-black h-full p-2 shadow-lg flex flex-col gap-4 overflow-scroll">
            <h2 className="font-bold text-lg">Quick Start Guide</h2>
            <p>
              To see what samples are on your tinker box, type{' '}
              <Code>list_samples</Code>
            </p>
            <p>
              To see what tools are on your tinker box, type{' '}
              <Code>list_tools</Code>
            </p>
            <p>
              For tool usage information, use the format{' '}
              <Code>{`<tool_name> -h`}</Code>
              <br />
              For example: <Code>extract_bedpe -h</Code>
            </p>
            <p>
              Want to call loops? Use this format:
              <br />
              <Code>
                <pre className="p-1">
                  {`extract_bedpe \\
    --sample1 GM12878_H3K27ac \\
    --genome hg38 \\
    --range chr8:126817755:129115254 > MYC_loops.bedpe`}
                </pre>
              </Code>
            </p>
            <p>
              Want to visualize loops? Use this format:
              <br />
              <Code>
                <pre className="p-1">
                  {`plot_contacts \\
    --sample1 GM12878_H3K27ac \\
    --genome hg38 \\
    --range chr8:126817755:129115254 \\
    --bedpe MYC_loops.bedpe \\
    --output_name MYC_loops.pdf`}
                </pre>
              </Code>
            </p>
            <p>
              Want to intersect loops? Use this format:
              <br />
              <Code>
                <pre className="p-1">
                  {`intersect_bedpe \\
--bedpe MYC_loops.bedpe \\
--bed_A <your_bed_file> > intersected_loops.bedpe`}
                </pre>
              </Code>
            </p>
            <p>
              For more info, check out these code snippets for
              <ul className="list-disc list-inside pl-4">
                <li>
                  <a
                    target="_blank"
                    href="https://docs.axiotl.com/workflows/snippets/calling_loops/"
                    className="underline cursor-pointer inline"
                  >
                    loop calling
                  </a>
                </li>
                <li>
                  <a
                    href="https://docs.axiotl.com/workflows/snippets/visualizing_loops/"
                    target="_blank"
                    className="underline cursor-pointer inline"
                  >
                    visualizing loops
                  </a>
                </li>
                <li>
                  <a
                    href="https://docs.axiotl.com/workflows/snippets/intersecting_loops/"
                    target="_blank"
                    className="underline cursor-pointer inline"
                  >
                    intersecting loops
                  </a>
                </li>
              </ul>
            </p>
            <p>
              For a deeper dive on loop calling, check out our extract_bedpe:
              <ul className="list-disc list-inside pl-4">
                <li>
                  <a
                    href="https://docs.axiotl.com/tools/extract_bedpe/"
                    target="_blank"
                    className="underline cursor-pointer inline"
                  >
                    conceptual tutorial
                  </a>
                </li>
                <li>
                  <a
                    href="https://docs.axiotl.com/workflows/recipes/recipe_01/"
                    target="_blank"
                    className="underline cursor-pointer inline"
                  >
                    biological recipe workflow
                  </a>
                </li>
              </ul>
            </p>
            <p>For support contact support@axiotl.com</p>
          </div>
        </div>
      )}
    </div>
  );
}
